export class Licencia {

  id_licencia: number;
  id_empresa: number;
  descripcion: string;
  comentarios: string;
  centros: Array<any>;
  id_tipo: number;
  vigenciafechafin: string;
  vigenciafechainicial: string;
  act: number;

  constructor(){
    this.id_licencia = 0;
    this.id_empresa = 0;
    this.descripcion = "";
    this.comentarios = "";
    this.centros = [];
    this.id_tipo = 0;
    this.vigenciafechafin = "";
    this.vigenciafechainicial = "";
    this.act = 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/licencia.model.ts